document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        var map = L.map('map').setView([20, 0], 2);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap contributors'
        }).addTo(map);

        var locations = [
            { name: "New York, USA", coords: [40.7128, -74.0060] },
            { name: "London, UK", coords: [51.5074, -0.1278] },
            { name: "Tokyo, Japan", coords: [35.6895, 139.6917] },
            { name: "Sydney, Australia", coords: [-33.8688, 151.2093] },
            { name: "Cape Town, South Africa", coords: [-33.9249, 18.4241] },
            { name: "Rio de Janeiro, Brazil", coords: [-22.9068, -43.1729] },
            { name: "Moscow, Russia", coords: [55.7558, 37.6173] },
            { name: "Dubai, UAE", coords: [25.276987, 55.296249] },
           { name: "Bharuch, India", coords: [21.7051, 72.9959] }
        ];

        locations.forEach(loc => {
            var marker = L.marker(loc.coords).addTo(map);
            marker.bindTooltip(loc.name, { permanent: false, direction: "top" });
        });
    }, 1000); // Delay to ensure proper loading
});
